<template>
  <b-modal
    v-model="modalOpen"
    size="xl"
    centered
    title="معلومات الأنشطة"
    footer-class="removed"
    class="edit-modal"
    static
  >
    <b-form-row>
      <b-col cols="12">
        <b-list-group class="rounded border">
          <b-list-group-item class="bg-secondary bg-lighten-3">
            <b-form-row class="text-white">
              <b-col> النشاط المرتبط بالهدف</b-col>
              <b-col> التمويل المرصود للنشاط </b-col>
              <b-col> نسبة تمويل النشاط من إجمالي الميزانية </b-col>
              <b-col> نوع مخرجات تنفيذ النشاط </b-col>
              <b-col> مؤشرات التنفيذ </b-col>
              <b-col> </b-col>
            </b-form-row>
          </b-list-group-item>
          <template v-if="loadingRecords">
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>جاري التحميل...</strong>
            </div>
          </template>
          <template v-else>
            <template v-if="records.length === 0 && !isAdding">
              <span class="text-center my-1" style="opacity: 0.7"
                >لا يوجد سجلات حتى الآن</span
              >
            </template>
            <b-list-group-item
              v-for="(activity, index) in records"
              :key="index"
            >
              <validation-observer
                v-if="isEdit === activity.id"
                ref="EditFormValidation"
              >
                <b-form
                  @submit.prevent="
                    toAdd.project_objective_id = goalId;
                    toAdd.project_id = $route.params.id;
                    onSubmit();
                  "
                >
                  <b-form-row>
                    <b-col>
                      <form-input
                        label="النشاط المرتبط بالهدف"
                        rules="required"
                        v-model="toAdd.name"
                      />
                    </b-col>

                    <b-col>
                      <form-cleave
                        label="التمويل المرصود للنشاط"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.expected_budget"
                        :raw="false"
                        :options="{
                          blocks: [15],
                          numericOnly: true,
                          delimiter: '',
                        }"
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="نسبة تمويل النشاط من إجمالي الميزانية"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.budget_percentage"
                        :raw="false"
                        :options="{
                          blocks: [15],
                          numericOnly: true,
                          delimiter: '',
                        }"
                      />
                    </b-col>
                    <b-col>
                      <form-select
                        label="نوع مخرجات تنفيذ النشاط"
                        rules="required"
                        :getOptionLabel="(x) => x.text"
                        :reduce="(x) => x.value"
                        :options="[
                          { text: 'نوعية', value: 0 },
                          { text: 'كمية', value: 1 },
                        ]"
                        v-model="toAdd.output_type"
                      />
                    </b-col>
                    <b-col>
                      <form-input
                        label="مؤشرات التنفيذ"
                        rules="required"
                        v-model="toAdd.expected_output"
                      />
                    </b-col>

                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isEdit = null"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
              <b-form-row v-else class="align-items-center">
                <b-col> {{ activity.name }}</b-col>
                <b-col> {{ activity.expected_budget }} </b-col>
                <b-col> {{ activity.budget_percentage }} </b-col>
                <b-col>
                  {{ activity.output_type === 1 ? "كمية" : "نوعية" }}
                </b-col>
                <b-col> {{ activity.expected_output }} </b-col>

                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="onEditClicked(activity, index)"
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    @click="onDeleteClicked(activity.id)"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-list-group-item>
            <b-list-group-item v-if="isAdding">
              <validation-observer ref="FormValidation">
                <b-form
                  @submit.prevent="
                    toAdd.project_objective_id = goalId;
                    toAdd.project_id = $route.params.id;

                    onSubmit();
                  "
                >
                  <b-form-row>
                    <b-col>
                      <form-input
                        label="النشاط المرتبط بالهدف"
                        rules="required"
                        v-model="toAdd.name"
                      />
                    </b-col>

                    <b-col>
                      <form-cleave
                        label="التمويل المرصود للنشاط"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.expected_budget"
                        :raw="false"
                        :options="{
                          blocks: [15],
                          numericOnly: true,
                          delimiter: '',
                        }"
                      />
                    </b-col>
                    <b-col>
                      <form-cleave
                        label="نسبة تمويل النشاط من إجمالي الميزانية"
                        rules="required"
                        id="id-num"
                        v-model="toAdd.budget_percentage"
                        :raw="false"
                        :options="{
                          blocks: [15],
                          numericOnly: true,
                          delimiter: '',
                        }"
                      />
                    </b-col>
                    <b-col>
                      <form-select
                        label="نوع مخرجات تنفيذ النشاط"
                        rules="required"
                        :getOptionLabel="(x) => x.text"
                        :reduce="(x) => x.value"
                        :options="[
                          { text: 'نوعية', value: 0 },
                          { text: 'كمية', value: 1 },
                        ]"
                        v-model="toAdd.output_type"
                      />
                    </b-col>
                    <b-col>
                      <form-input
                        label="مؤشرات التنفيذ"
                        rules="required"
                        v-model="toAdd.expected_output"
                      />
                    </b-col>
                    <b-col
                      class="justify-content-end d-flex pt-50 align-items-center"
                    >
                      <b-button
                        @click="isAdding = false"
                        variant="flat-secondary  "
                        class="mx-50"
                      >
                        إلغاء
                      </b-button>
                      <loader-btn
                        :loading="working"
                        variant="primary"
                        type="submit"
                      >
                      </loader-btn>
                    </b-col>
                  </b-form-row>
                </b-form>
              </validation-observer>
            </b-list-group-item>
          </template>
        </b-list-group>
        <b-form-row class="px-50 mt-1 d-flex justify-content-end">
          <b-button @click="onNewClicked" variant="success">
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-form-row>
      </b-col>
    </b-form-row>
  </b-modal>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BFormRow,
  BCol,
  BForm,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input";
import FormSelect from "@/components/form-select";
import FormDatepicker from "@/components/form-datepicker";
import FormCleave from "@/components/FormCleave.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import tableEditMixin from "../mixins/TableEditMixin";

export default {
  mixins: [tableEditMixin],
  props: {
    value: Boolean,
    goalId: Number,
  },
  components: {
    FormInput,
    BButton,
    BFormGroup,
    BSpinner,
    BListGroup,
    BListGroupItem,
    BFormRow,
    BCol,
    LoaderBtn,
    BForm,
    ValidationObserver,
    FormSelect,
    FormDatepicker,
    FormCleave,
    Cleave,
  },
  data() {
    return {
      isActivitiesModalOpened: false,
    };
  },

  watch: {
    modalOpen(val) {
      if (val) this.refreshData();
    },
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },

    fetchEndpoint() {
      return `v2/co-op/project/${this.$route.params.id}/activities`;
    },
    operationsEndpoint() {
      return `v2/co-op/project/activities`;
    },
  },
};
</script>
